import {
	init,
	type GenericAnalyticWebClientPromise,
} from '@atlassian/ufo-interaction-metrics-init';

import { getAnalyticsWebClient } from '@confluence/analytics-web-client';
import { getSSRFeatureFlag } from '@confluence/ssr-utilities';

import { additionalPayloadData } from './additionalPayloadData';
import { getSSRDoneTime, getSSRTimings } from './ssr';
import { configure as configureSsrTiming } from '@atlassian/ufo-ssr';
import { getMark } from '@confluence/performance';

const getConfig = (sessionData: any) => {
	const { featureFlags } = sessionData;
	try {
		return JSON.parse(featureFlags['confluence.frontend.ufo.config']);
	} catch (e) {
		return;
	}
};

export function initUFO(sessionData: any) {
	const config = getConfig(sessionData);

	if (!config || !config.enabled) {
		return;
	}
	const vcConfig = {
		heatmapSize: 200,
		oldDomUpdates: false,
		devToolsEnabled: Boolean(getSSRFeatureFlag('confluence.ssr.enable.ttvc.devtool')),
		selectorConfig: {
			id: false,
			role: false,
			className: true,
			testId: false,
		},
	};
	const enableTTVC = getSSRFeatureFlag('confluence.ssr.enable.ttvc');

	configureSsrTiming({
		getDoneMark: () => getMark('CFP-63.ssr-ttr') ?? null, // from confluence/next/packages/browser-metrics/src/initializeBrowserMetrics.ts
		// TODO: add correct functions to `getTimings` and `getFeatureFlags`
		getTimings: () => null,
		getFeatureFlags: () => null,
	});

	init(getAnalyticsWebClient() as Promise<GenericAnalyticWebClientPromise>, {
		product: 'confluence',
		region: sessionData.shard || 'unknown',
		enableTTVC: false,
		vc: {
			enabled: Boolean(enableTTVC),
			...vcConfig,
		},
		...config,
		ssr: { getSSRDoneTime, getSSRTimings },
		additionalPayloadData,
	});
}
